import { FormSubscriberService as OvermapFormSubscriberService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormSubscriberService extends OvermapFormSubscriberService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
